import { toMillis } from '@bridebook/toolbox/src/time-utils/time-utils';
import { getDerivedParams, ISearchParams } from '@bridebook/web/lib/search/hooks/query/use-search';
import { useWeddingVenueInteractions } from '@bridebook/web/lib/search/hooks/query/use-wedding-venue-interactions';
import { useQuery } from '@tanstack/react-query';
import { SearchQueryKey } from '@bridebook/web/lib/search/constants';

export const SEARCH_QUERY_CACHE_TIME = toMillis(15, 'min');

export const useDerivedSearchParams = (params?: ISearchParams) => {
  const { data: venueHistory, isFetched: isVenueHistoryFetched } = useWeddingVenueInteractions();

  const { data, isLoading, error } = useQuery({
    queryKey: [SearchQueryKey.DerivedParams, params],
    queryFn: () => {
      if (!params) {
        return Promise.resolve(undefined);
      }
      return getDerivedParams(params, venueHistory);
    },
    enabled: !!params && isVenueHistoryFetched,
    staleTime: SEARCH_QUERY_CACHE_TIME,
    cacheTime: SEARCH_QUERY_CACHE_TIME,
  });

  return { data, isLoading, error };
};
